<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions } from 'vuex';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import createUploadFile from '@/utils/createUploadFile';
import bem from '@/utils/bem';

const b = bem('article-ad-images');
export default {
  components: { UploadImages },
  data() {
    return {
      isMultiple: false,
      beforeFileList: [],
      imageDesktopUri: '',
      imageAlt: '',
      title: '',
      description: '',
      buttonText: '',
      buttonLink: '',
    };
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addOrEditCategory: 'blogs/addOrEditCategory',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onCancel() {
      this.hideModal();
      this.$emit('update:adBlockData', {});
    },
    onSave() {
      this.hideModal();
      this.$emit('update:adBlockData', {
        imageDesktopUri: this.imageDesktopUri,
        title: this.title,
        description: this.description,
        buttonText: this.buttonText,
        buttonLink: this.buttonLink,
        imageAlt: this.imageAlt,
      });
    },
    async getUrl(uploadingFile, imageType) {
      const { url, file } = uploadingFile;
      let imageUrl = '';
      if (file) {
        const {
          data: {
            data: uploadedFile,
          },
        } = await createUploadFile(url, 'images-blog');
        imageUrl = uploadedFile.url;
      } else {
        imageUrl = url;
      }

      switch (imageType) {
        case 'before':
          this.imageDesktopUri = imageUrl;
          return null;
        default:
          return null;
      }
    },
  },
  watch: {
    beforeFileList(newValue) {
      if (newValue.length) {
        this.getUrl(newValue[0], 'before');
      } else {
        this.imageDesktopUri = '';
      }
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="onCancel" >
    <h1>
      Ad block
    </h1>
    <div :class="b('images-wrapper')">
      <div :class="b('image-block')">
        <h2>Image:</h2>
        <UploadImages
          v-model:files="beforeFileList"
          :isMultiple="isMultiple"
          :classProps="b('uploader')"
        />
        <a-form-item label="Image alt" name="imageAlt">
          <a-input v-model:value="imageAlt" style="width: 200px"/>
        </a-form-item>
      </div>
      <div :class="b('content')">
        <a-form-item label="Title" name="title">
          <a-input v-model:value="title" style="width: 250px"/>
        </a-form-item>
        <a-form-item label="Description" name="description">
          <a-input v-model:value="description" style="width: 250px"/>
        </a-form-item>
        <a-form-item label="Button text" name="buttonText">
          <a-input v-model:value="buttonText" style="width: 250px"/>
        </a-form-item>
        <a-form-item label="Button link" name="buttonLink">
          <a-input v-model:value="buttonLink" style="width: 250px"/>
        </a-form-item>
      </div>
    </div>
    <div :class="b('buttons')" v-if="beforeFileList.length">
      <a-spin
        v-if="beforeFileList.length && !imageDesktopUri"
        size="large"
      />
      <a-button
        v-if="imageDesktopUri"
        type="primary"
        :class="b('save-button')"
        @click="onSave"
      >
        Save
      </a-button>
    </div>
  </a-modal>
</template>

<style lang="scss">
.article-ad-images {

  &__images-wrapper {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: space-evenly;
  }

  &__image-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__buttons {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    padding: 0 30px;
  }

  &__save-button {
    height: 40px;
    width: 120px;
    font-size: 20px;
  }

  &__uploader {
    .ant-upload-list-picture-card,
    .ant-upload-list-picture-select-card,
    .ant-upload-select,
    .ant-upload,
    .ant-upload-list-item-container {
      width: 200px !important;
      height: 200px !important;
    }
  }
}
</style>
